// auto-generated by bin/genVersion.ts
export const VERSION = '2.2.4';
